import { useState } from 'react';
import { useAppDispatch, useAppSelector } from "../commons/store/hooks";
import {
  selectTransferFileDownloading,
  transferDownloadFiles
} from "../features/survey/redux/elementResourceTransferSlice";

export function useDownloadFile() {
  const dispatch = useAppDispatch();
  const isDownloading = useAppSelector(selectTransferFileDownloading);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const downloadFile = async (id: string) => {
    setLoading(true);
    setError(null);

    try {
      await dispatch(transferDownloadFiles(id));
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { downloadFile, loading, isDownloading, error };
}
